// Shared layout constants so the banner's content and the form card line up
// on the same left/right edges even though the banner itself is full-bleed.
export const CARD_MAX_WIDTH = 840;
export const CARD_OVERLAP = '80px';

// Figma: Rectangle 57 — linear gradient header (1597×171 in design file).
export const BANNER_HEIGHT = 171;
export const BANNER_GRADIENT = 'linear-gradient(180deg, #2E3F80 0%, #1C264D 100%)';

// Reference design values for the floating card over the hero banner.
export const CARD_BORDER_RADIUS = '12px';
export const CARD_BOX_SHADOW = '0px 8px 24px rgba(15, 23, 42, 0.12)';
export const BANNER_SUBTITLE_COLOR = 'rgba(255, 255, 255, 0.85)';
